
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/financial/forecast",
      function () {
        return require("private-next-pages/ir/financial/forecast.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/financial/forecast"])
      });
    }
  